import { type GetFeatureFlagsQueryParams } from '@gonfalon/openapi/operations/getFeatureFlags';

import { creationDateRangeToDate } from './internal/creationDateRangeToDate';
import { evaluatedDateRangeToDate } from './internal/evaluatedDateRangeToDate';
import { baseLifecycleStatesSchema, staleStatesSchema, type UIFlagFilter } from './types';

export function serializeUIFlagFilterForAPI(filter: UIFlagFilter) {
  const apiFilter: NonNullable<GetFeatureFlagsQueryParams['filter']> = {};
  apiFilter.query = filter.query;
  apiFilter.maintainerId = filter.maintainerId;
  apiFilter.maintainerTeamKey = filter.maintainerTeamKey;
  apiFilter.tags = filter.tags;
  apiFilter.type = filter.type;
  apiFilter.sdkAvailability = filter.sdkAvailability;
  apiFilter.guardedRollout = filter.guardedRollout;
  apiFilter.filterEnv = filter.filterEnv;
  apiFilter.view = filter.view;
  apiFilter.status = filter.status;
  // Since the UI contains all potential states
  const validAPIFilterState = baseLifecycleStatesSchema.safeParse(filter.state);
  const validAPIFilterStateStates = staleStatesSchema.safeParse(filter.state);
  apiFilter.state = validAPIFilterState.success ? validAPIFilterState.data : undefined;
  apiFilter.staleStates = validAPIFilterStateStates.success ? validAPIFilterStateStates.data : undefined;
  apiFilter.applicationEvaluated = filter.applicationEvaluated;
  apiFilter.segmentTargeted = filter.segmentTargeted;
  apiFilter.excludeSettings = filter.excludeSettings;
  apiFilter.applicationEvaluated = filter.applicationEvaluated;
  apiFilter.purpose = filter.purpose;

  const now = Date.now();

  if (filter.evaluated !== undefined) {
    const evaluatedDate = evaluatedDateRangeToDate(filter.evaluated, now);
    apiFilter.evaluated = evaluatedDate ? { after: evaluatedDate.getTime() } : undefined;
  }

  if (filter.created !== undefined) {
    const createdDate = creationDateRangeToDate(filter.created, now);
    apiFilter.creationDate = createdDate ? { before: createdDate.getTime() } : undefined;
  }

  return apiFilter;
}
